import styled from 'styled-components'
import { ZdsTextButton } from '@zera/components'

export const MenuOption = styled(ZdsTextButton).attrs(props => ({
  ...props,
  variant: 'secondary-inverse'
}))`
  width: 100%;

  .ZdsTypography {
    white-space: normal;
    overflow: visible;
    height: auto;
    text-align: center;
  }

  &:hover {
    background: ${({ theme }) => theme.zds.colors.blue400};
  }
`
